import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/protected/_layout/help/$category')({
  component: HelpCategoryRoute,
});

function HelpCategoryRoute() {
  return <Outlet />;
}
